module.exports = __webpack_public_path__ + "img/banner_pt.21383b4f.jpg";